import { Styles, Options } from 'react-joyride';

/**
 * Custom Joyride theme options generator
 */
export const getTourOptions = (): Partial<Options> => ({
  zIndex: 10000,
  arrowColor: 'var(--admin-bg-container, #010204)',
  overlayColor: 'rgba(0, 0, 0, 0.75)',
  spotlightRadius: 0,
  spotlightPadding: 6,
  scrollOffset: 140,
  hideOverlay: false,
});

/**
 * Custom Joyride theme styles generator with sharp 0px corners and high-contrast SVG spotlight outline
 */
export const getTourStyles = (): Partial<Styles> => ({
  spotlight: {
    stroke: '#38bdf8',
    strokeWidth: 2,
    style: {
      filter: 'drop-shadow(0 0 10px rgba(56, 189, 248, 0.8))',
    },
  },
  beaconInner: {
    backgroundColor: '#38bdf8',
  },
  beaconOuter: {
    borderColor: '#38bdf8',
  },
});

